import React from 'react';
import StoryListing from '@stone/components/storylisting/StoryListing';
const StoryListingLoader = (props) => {
    const parsed = JSON.parse(props.stories);
    return React.createElement(StoryListing, { title: props.title, stories: parsed });
};
export default StoryListingLoader;
